export default "__VITE_ASSET__gdjRYa7y__"